// Event
export const EVENT_LIST_SUCCESS = 'EVENT_LIST_SUCCESS';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
// Event Type:
export const EVENT_TYPE_LIST_SUCCESS = 'EVENT_TYPE_LIST_SUCCESS';
export const CREATE_EVENT_TYPE_SUCCESS = 'CREATE_EVENT_TYPE_SUCCESS';
export const UPDATE_EVENT_TYPE_SUCCESS = 'UPDATE_EVENT_TYPE_SUCCESS';
export const DELETE_EVENT_TYPE_SUCCESS = 'DELETE_EVENT_TYPE_SUCCESS';
// Event Occurrence:
export const EVENT_OCCURRENCE_CALENDAR_LIST_TOKEN = 'EVENT_OCCURRENCE_CALENDAR_LIST_TOKEN';
export const EVENT_OCCURRENCE_CALENDAR_LIST_UPDATE = 'EVENT_OCCURRENCE_CALENDAR_LIST_UPDATE';
export const EVENT_OCCURRENCE_CALENDAR_LIST_SUCCESS = 'EVENT_OCCURRENCE_CALENDAR_LIST_SUCCESS';
export const EVENT_OCCURRENCE_CALENDAR_LIST_ERROR = 'EVENT_OCCURRENCE_CALENDAR_LIST_ERROR';
export const EVENT_OCCURRENCE_CALENDAR_LIST_RESET = 'EVENT_OCCURRENCE_CALENDAR_LIST_RESET';
